"use client"

import type React from "react"
import { memo } from "react"
import type { User, UserMenuAction } from "../../../types/header"
import UserAvatar from "./UserAvatar"

interface UserMenuDropdownProps {
  user: User
  actions: UserMenuAction[]
  isOpen: boolean
}

const UserMenuDropdown: React.FC<UserMenuDropdownProps> = memo(({ user, actions, isOpen }) => {
  if (!isOpen) return null

  return (
    <div className="user-menu-dropdown">
      <div className="user-menu-header">
        <UserAvatar size="large" className="user-avatar-large" />
        <div className="user-details">
          <div className="user-name">
            {user.first_name} {user.last_name}
          </div>
          <div className="user-email">{user.email}</div>
        </div>
      </div>

      <div className="user-menu-items">
        {actions.map((action, index) => (
          <div key={action.label}>
            {action.variant === "danger" && index > 0 && <div className="menu-divider" />}
            <button
              onClick={action.onClick}
              className={`user-menu-item ${action.variant === "danger" ? "logout" : ""}`}
            >
              {action.icon}
              {action.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  )
})

UserMenuDropdown.displayName = "UserMenuDropdown"

export default UserMenuDropdown
